import React from 'react';
import ClickableContainer from 'components/clickable-container';

const AnalyticsTabHeader = ({ children, isActive, onClick }: { children: React.ReactNode; isActive: boolean; onClick?: () => void }) => (
  <ClickableContainer
    className={`d-flex align-items-center card-title ml-4 px-4 ${isActive ? 'bottom-border-clickable pt-1' : ''}`}
    onClick={() => onClick?.()}
  >
    {children}
  </ClickableContainer>
);

export default AnalyticsTabHeader;
